<div class="delivery-pod" [style.--color]="brandColor">
  <div class="notes-section" *ngIf="notes && notes.length > 0">
    <div class="notes-title">{{ isExternalPickup ? 'Collection note' : 'Delivery note' }}</div>
    <div class="notes" *ngFor="let note of notes">
      <p [innerText]="note"></p>
    </div>
  </div>
  <div class="photos-container" *ngIf="proofOfDelivery.length">
    <mat-expansion-panel
      [@.disabled]="panelAnimationDisabled"
      class="proof-of-delivery"
      togglePosition="before"
      [expanded]="singleOrderView"
      (expandedChange)="trackPhotosPanel($event)">
      <mat-expansion-panel-header *ngIf="!singleOrderView">
        <mat-panel-title>Parcel photo/ Signature</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="proof-of-delivery-contents">
        <ng-container *ngFor="let proofItem of proofOfDelivery">
          <ng-template
            [ngTemplateOutlet]="images"
            [ngTemplateOutletContext]="{
              title: proofItem.type === TypeEnum.Photo ? 'Photo' : 'Signature',
              imageUrls: proofItem.urls,
              isSignature: proofItem.type === TypeEnum.Signature,
            }">
          </ng-template>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </div>
</div>

<ng-template #images let-title="title" let-imageUrls="imageUrls" let-isSignature="isSignature">
  <div class="proof-of-delivery-images">
    <div class="label">{{ title }}</div>
    <div class="images" *ngIf="isSignature">
      <div class="image" [class.signature]="isSignature" *ngFor="let photoUrl of imageUrls">
        <div *ngIf="!isUrlLoaded(photoUrl)" class="img-loader"></div>
        <img
          [src]="photoUrl"
          (click)="openImagePreview(photoUrl, true, $event)"
          (load)="setUrlLoaded(photoUrl)"
          (error)="handleMissingImage($event, photoUrl)"
          alt="" />
      </div>
    </div>
    <div *ngIf="!isSignature" #carouselContainer>
      <p-carousel
        [value]="imageUrls"
        [class.extra-arrows]="singleOrderView"
        [numVisible]="singleOrderView ? carouselContainer.getBoundingClientRect().width / 146 : 2.5"
        [numScroll]="1"
        [showNavigators]="!isMobileMode"
        [contentClass]="imageUrls.length > 2 ? 'pod' : 'pod two-items'">
        <ng-template let-imageUrl pTemplate="item">
          <div
            class="carousel-image-container"
            (click)="openImagePreview(imageUrl, false, $event)"
            [class.two-items]="imageUrls.length === 2">
            <div *ngIf="!isUrlLoaded(imageUrl)" class="img-loader"></div>
            <img
              src="{{ imageUrl }}"
              (load)="setUrlLoaded(imageUrl)"
              (error)="handleMissingImage($event, imageUrl)"
              alt="" />
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</ng-template>

<p-overlayPanel #imagePreviewOp [styleClass]="'pod'">
  <div class="container" (click)="imagePreviewOp.hide()">
    <div class="img-container">
      <button class="button-close" (click)="imagePreviewOp.hide()">
        <img src="../../../assets/close-button.svg" />
      </button>
      <img [src]="imageForPreview" (click)="$event.stopPropagation()" />
    </div>
  </div>
</p-overlayPanel>
